export default __webpack_public_path__ + "static/media/04.1d07d907.svg";